import { Theme } from "@mui/material";
import { fontSize, textAlign } from "@mui/system";

const useStyles = (theme: Theme) => ({
  stackPage: {
    width: "100%",
    height: "100%",
    padding: { xs: "10%", md: "50px" },
  },
  paperForm: {
    padding: "24px 32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: { xs: "100%", md: "500px" },
    minWidth: "200px",
    gap: "12px",
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
  },
  subtitle: {
    fontSize: "14px",
    color: theme.palette.text.secondary,
    fontWeight: 500,
    textAlign: "center",
  },
  backgroundBox: {
    zIndex: -1,
    height: "100vh",
    width: "100vw",
    position: "absolute" as const,
    top: 0,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    filter: "blur(5px)",
  },
  paperContainer: {
    minWidth: "350px",
    padding: "20px 50px",
    width: { xs: "90vw", sm: "500px" },
    margin: "auto",
    marginTop: "20vh",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    display: "flex",
  },
  stackContainer: {
    direction: "column",
    gap: "15px",
    alignItems: "center",
    padding: "0px",
    width: "100%",
  },
  logoImage: {
    height: "auto",
    width: "250px",
  },
  descriptionText: {
    fontSize: "1em",
    fontFamily: "Rubik",
    textAlign: "center" as const,
  },
  formControl: {
    m: 1,
    width: "90%",
    marginTop: "10px",
  },
  button: {
    width: "90%",
    borderRadius: "5px",
    marginTop: "10px",
    height: "40px",
    marginBottom: "20px",
  },
  feedbackText: {
    fontSize: "1.2em",
    fontFamily: "Rubik",
    textAlign: "center" as const,
    mb: "20px",
    padding: "10px",
    backgroundColor: "rgba(0, 0, 0,0.1)",
  },
  linkText: {
    fontSize: "0.8em",
    textAlign: "center" as const,
  },
});

export default useStyles;
